import { render } from "./FollowUpStatus.vue?vue&type=template&id=2ceee6b2&scoped=true"
import script from "./FollowUpStatus.vue?vue&type=script&lang=js"
export * from "./FollowUpStatus.vue?vue&type=script&lang=js"

import "./FollowUpStatus.vue?vue&type=style&index=0&id=2ceee6b2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ceee6b2"]])

export default __exports__